import React, { useEffect, useState, useRef, useCallback } from 'react';
import { getData, postData, deleteData, putData } from '../../services/apiService';
import Layout from '../../components/layout/Layout';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography,
    IconButton, Button, TextField, Select, MenuItem, Pagination, InputAdornment,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useAuth } from '../../contexts/AuthContext';

const AddQuiz = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [lessiondata, setLessionData] = useState([]);
    const isFetched = useRef(false);
    const [showQuizModal, addQuizShowModal] = useState(false);
    const [updateQuizModalShow, updateQuizModal] = useState(false);
    const [selectedQuiz, setSelectedQuiz] = useState(null);
    const [formData, setFormData] = useState({ lessonId: "", title: "", instructions: "", timeLimit: "", status: "", createdBy: "", college_id: "" });
    // Pagination and search states
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [totalPages, setTotalPages] = useState(1);

    // Fetch all Quiz from the API
    const fetchData = useCallback(async () => {
        try {
            const response = await getData(`/get-all-quiz?page=${page}&limit=${rowsPerPage}&search=${searchQuery}`);
            if (response) {
                setData(response.data);
                setTotalPages(response.totalPages);
            }
        } catch (error) {
            console.error('Failed to fetch data', error);
        }
    }, [page, rowsPerPage, searchQuery]);

    // onload
    useEffect(() => {
        if (!isFetched.current) {
            fetchData();
            getLession();
        }
    }, [fetchData]);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setPage(1); // Reset to first page on new search
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(event.target.value);
        setPage(1);
    };

    // Fetch all Lession from the API
    const getLession = async () => {
        try {
            const response = await getData('/get-lessons-for-dropdown');
            if (response) {
                setLessionData(response);
            }
        } catch (error) {
            console.error('Failed to fetch data', error);
        }
    };

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Add new Quiz!
    const AddQuiz = async (e) => {
        e.preventDefault();
        try {
            const dataToSend = {
                ...formData,
                college_id: user.college_id,
                createdBy: user._id,
            };
            await postData('/create-quiz', dataToSend);
            setFormData({ lessonId: "", title: "", instructions: "", timeLimit: "", status: "", createdBy: "", college_id: "" });
            addQuizShowModal(false);
            fetchData();
        } catch (error) {
            console.error('Failed to post data', error);
        }
    };

    // Edit Quiz
    const editQuiz = (id) => {
        const quizData = data.find(quiz => quiz._id === id);
        setSelectedQuiz(quizData);
        updateQuizModal(true);
    };

    // Update Quiz
    const updateQuiz = async () => {
        if (!selectedQuiz) return;
        const updatedData = {
            title: selectedQuiz.title,
            instructions: selectedQuiz.instructions,
            timeLimit: selectedQuiz.timeLimit,
            status: selectedQuiz.status,
            college_id: selectedQuiz?.college_id?._id || selectedQuiz.college_id,
            createdBy: selectedQuiz?.createdBy?._id || selectedQuiz.createdBy,
            lessonId: selectedQuiz?.lessonId?._id || selectedQuiz.lessonId,
        };

        try {
            await putData(`/update-quiz/${selectedQuiz._id}`, updatedData);
            fetchData();
            updateQuizModal(false);
        } catch (error) {
            console.error('Failed to update user', error);
        }

    };

    // Delete Section!
    const deleteQuiz = async (id) => {
        try {
            await deleteData(`/delete-quiz/${id}`);
            await fetchData();
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <Layout>
            <Box className="p-6 bg-gray-100 min-h-screen">
                <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold', mb: 3 }}>Quiz Data</Typography>
                {/* Header: Add Button (left) and Search (right) */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 2, }} >
                    <Button variant="contained" sx={{
                        borderRadius: 2, fontWeight: 600, boxShadow: 2, px: 3, py: 1, textTransform: 'none', backgroundColor: '#4B49AC',
                        '&:hover': { backgroundColor: '#3A3897', },
                    }} onClick={() => addQuizShowModal(true)} > + Add Quiz </Button>
                    <TextField placeholder="Search Departments" value={searchQuery} onChange={handleSearchChange} variant="outlined" size="medium"
                        sx={{ width: 350, bgcolor: '#e9ecef', borderRadius: 2, '& .MuiOutlinedInput-root': { borderRadius: 2, }, }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: '#757575' }} />
                                </InputAdornment>
                            ),
                            sx: { bgcolor: '#e9ecef', borderRadius: 2 },
                        }}
                    />
                </Box>
                {/* <TableContainer component={Paper} elevation={0} sx={{ mb: 2, borderRadius: 2, boxShadow: 2, overflow: 'hidden', }} > */}

                <TableContainer component={Paper}
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        overflowX: "auto",
                        overflowY: "hidden",
                        "&::-webkit-scrollbar": {
                            height: "8px"
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#888",
                            borderRadius: "4px"
                        }
                    }}
                >
                    <Table>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#4B49AC' }}>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopLeftRadius: 8 }}> ID </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Lesson </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Title </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Instructions </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Time Limit </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Status </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600 }}> Created By </TableCell>
                                <TableCell align="center" sx={{ color: 'white', fontWeight: 600, borderTopRightRadius: 8 }}> Action </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((item, index) => (
                                <TableRow key={item._id}>
                                    <TableCell align="center">
                                        <Typography variant="body1">{(page - 1) * rowsPerPage + index + 1}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="body1">{item?.lessonId?.title}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="body1">{item?.title}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="body1">{item.instructions}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="body1">{item.timeLimit}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="body1">{item.status}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <Typography variant="body1">{item.createdBy?.firstName}</Typography>
                                    </TableCell>
                                    <TableCell align="center">
                                        <IconButton color="primary" onClick={() => editQuiz(item._id)}>
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton color="error" onClick={() => deleteQuiz(item._id)}>
                                            <DeleteIcon />
                                        </IconButton>
                                        <IconButton color="success" onClick={() => navigate(`/add-quiz-question?quizId=${item._id}`)}>
                                            <VisibilityIcon />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                {/* Pagination */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Pagination count={totalPages} page={page} onChange={handlePageChange} shape="rounded"
                        sx={{
                            '& .MuiPaginationItem-root': {
                                '&.Mui-selected': {
                                    bgcolor: '#4B49AC',
                                    color: 'white',
                                },
                            },
                        }}
                    />
                    <Select value={rowsPerPage} onChange={handleRowsPerPageChange} size="small"
                        sx={{ ml: 2, height: 35, bgcolor: '#f7f7f7', border: '1px solid #e2e2e2', '& .MuiSelect-select': { py: 0.75 }, }}
                        IconComponent={KeyboardArrowDownIcon} >
                        <MenuItem value={10}>10 / page</MenuItem>
                        <MenuItem value={20}>20 / page</MenuItem>
                        <MenuItem value={50}>50 / page</MenuItem>
                    </Select>
                </Box>

                {/* Quiz Add model */}
                <Modal show={showQuizModal} onHide={() => addQuizShowModal(false)} style={{ zIndex: 9999 }} >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Quiz</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* { lessonId: "", title: "", instructions: "", timeLimit: "", status: "", createdBy: "" } */}
                        <form onSubmit={AddQuiz}>
                            <div className="mb-3">
                                <label className="col-form-label">Lesson:</label>
                                <select className="form-select" name="lessonId" value={formData.lessonId} onChange={handleInputChange} >
                                    <option value="">Select Lession</option>
                                    {lessiondata.map((lession) => (
                                        <option key={lession._id} value={lession._id}>{lession.title}</option>
                                    ))}
                                </select>
                                <label htmlFor="title" className="col-form-label">Title:</label>
                                <input type="text" className="form-control" id="title" placeholder="Title" name='title' value={formData?.title} onChange={handleInputChange} />

                                <label htmlFor="instructions" className="col-form-label">Instructions:</label>
                                <textarea type="text" className="form-control" id="instructions" placeholder="Instructions" name='instructions' value={formData.instructions} onChange={handleInputChange} />

                                <label htmlFor="timeLimit" className="col-form-label">Time Limit:</label>
                                <input type="number" className="form-control" id="timeLimit" placeholder="Time Limit" name='timeLimit' value={formData.timeLimit} onChange={handleInputChange} />

                                <label htmlFor="status" className="col-form-label">Status:</label>
                                <select className="form-select" name="status" value={formData.status} onChange={handleInputChange} >
                                    <option value="">Select Status</option>
                                    <option value="published">Published</option>
                                    <option value="draft">Draft</option>
                                </select>

                                {/* <label className="col-form-label">Created By:</label>
                                <select className="form-select" name="createdBy" value={formData.createdBy} onChange={handleInputChange} >
                                    <option value="">Select Created By</option>
                                    {adminAndInstructorData.map((createdByDate) => (
                                        <option key={createdByDate._id} value={createdByDate._id}>{createdByDate?.firstName}</option>
                                    ))}
                                </select> */}

                            </div>
                            <Modal.Footer>
                                <Button variant="contained" type="submit" color="primary" sx={{ bgcolor: '#3A3897', '&:hover': { bgcolor: '#2A2878', } }}>Save</Button>
                            </Modal.Footer>
                        </form>
                    </Modal.Body>
                </Modal>

                {/* Quiz update model */}
                <Modal show={updateQuizModalShow} onHide={() => updateQuizModal(false)} style={{ zIndex: 9999 }} >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Quiz</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <div className="mb-3">
                                <label className="col-form-label">Lesson:</label>
                                <select className="form-select" name="lessonId" value={selectedQuiz?.lessonId?._id || selectedQuiz?.lessonId?._id} onChange={(e) => setSelectedQuiz({ ...selectedQuiz, lessonId: e.target.value })}  >
                                    <option value="">Select Lession</option>
                                    {lessiondata.map((lession) => (
                                        <option key={lession._id} value={lession._id}>{lession?.title}</option>
                                    ))}
                                </select>

                                <label htmlFor="title" className="col-form-label">Title:</label>
                                <input type="text" className="form-control" value={selectedQuiz?.title || ""} onChange={(e) => setSelectedQuiz({ ...selectedQuiz, title: e.target.value })} required />

                                <label htmlFor="instructions" className="col-form-label">Instructions:</label>
                                <textarea type="text" className="form-control" value={selectedQuiz?.instructions || ""} onChange={(e) => setSelectedQuiz({ ...selectedQuiz, instructions: e.target.value })} />

                                <label htmlFor="timeLimit" className="col-form-label">Time Limit:</label>
                                <input type="number" className="form-control" value={selectedQuiz?.timeLimit || ""} onChange={(e) => setSelectedQuiz({ ...selectedQuiz, timeLimit: e.target.value })} />

                                <label htmlFor="status" className="col-form-label">Status:</label>
                                <select className="form-select" value={selectedQuiz?.status || ""} onChange={(e) => setSelectedQuiz({ ...selectedQuiz, status: e.target.value })} >
                                    <option value="">Select Status</option>
                                    <option value="published">Published</option>
                                    <option value="draft">Draft</option>
                                </select>

                                {/* <label className="col-form-label">Created By:</label>
                                <select className="form-select" value={selectedQuiz?.createdBy?._id} onChange={(e) => setSelectedQuiz({ ...selectedQuiz, createdBy: e.target.value })}  >
                                    <option value="">Select Created By</option>
                                    {adminAndInstructorData.map((createdByDate) => (
                                        <option key={createdByDate._id} value={createdByDate._id}>{createdByDate?.firstName}</option>
                                    ))}
                                </select> */}

                            </div>
                            <Modal.Footer>
                                <Button variant="contained" onClick={updateQuiz} color="primary" sx={{ bgcolor: '#3A3897', '&:hover': { bgcolor: '#2A2878', } }}>Save changes</Button>
                            </Modal.Footer>
                        </form>
                    </Modal.Body>
                </Modal>
            </Box>
        </Layout>
    );
};

export default AddQuiz;